/**
 * 分析页面 横向比例柱图
 * @param dataArr [{name:'',value:0,unit:''}]y轴数据合集
 */
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let index = 0;
  let maxNum = 0;
  paramObj.dataArr.map((v) => {
    maxNum += v.value;
  });
  let colorList = [
    { color: "#51E8E7", color1: "#28CCCB" },
    { color: "#92D0FA", color1: "#59A3F3" },
  ];
  let option = {
    grid: {
      left: "1%",
      right: "1%",
      top: "1%",
      bottom: "1%",
      containLabel: true,
    },
    legend: {
      show: true,
      // top: "60%",
      bottom: "1%",
      left: "center",
      fontSize: 12,
      formatter: (params) => {
        let result = "";
        if (paramObj.dataArr[index].unit) {
          result = `${params}:\n${dealBigNum(paramObj.dataArr[index].value)} ${
            paramObj.dataArr[index].unit
          }`;
        } else {
          result = `${params}:${dealBigNum(paramObj.dataArr[index].value)}`;
        }

        index++;
        return result;
      },
      itemHeight: 10,
      itemWidth: 10,
      selectedMode: false,
    },
    // color: ["#fc874b", "#fad336"],
    xAxis: {
      show: false,
      type: "value",
      boundaryGap: [0, 0],
    },
    yAxis: [
      {
        type: "category",
        data: [""],
        axisLine: { show: false },
        axisTick: [
          {
            show: false,
          },
        ],
      },
    ],
    series: [],
  };
  paramObj.dataArr.map((v, i) => {
    option.series.push({
      type: "bar",
      name: v.name,
      stack: "总量",
      barWidth: 20,
      label: {
        show: true,
        position: "inside",
        color: "#fff",
        formatter: (params) => {
          return params.value == 0
            ? ""
            : Number((params.value / maxNum) * 100).toFixed(2) + "%";
        },
      },
      showBackground: true,
      backgroundStyle: {
        color: "#fff",
        borderRadius: 10,
      },
      itemStyle: {
        color: {
          x: 1,
          y: 1,
          x2: 0,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: colorList[i].color,
            },
            {
              offset: 1,
              color: colorList[i].color1,
            },
          ],
        },
        borderRadius: i == 0 ? [10, 0, 0, 10] : [0, 10, 10, 0],
      },
      data: [v.value],
    });
  });

  return option;
}
